import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import { AUTHORITY_BUILDER_LOGIN_URL } from '../../config/partnerAccess';

const navigation = [
  { label: 'How It Works', to: '/agency-how-it-works' },
  { label: 'Partner Options', to: '/partners' },
  { label: 'Local business?', to: '/for-local-businesses' },
  { label: 'Resources', to: '/resources' },
];

export default function AgencyNavbar() {
  const [isOpen, setIsOpen] = useState(false);

  useBodyScrollLock(isOpen);

  const closeMenu = () => setIsOpen(false);

  return (
    <><a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-24 focus:z-[100] focus:bg-white focus:p-4">Skip to content</a><header className="fixed inset-x-0 top-0 z-[70] border-b border-[#244A49]/10 bg-[#F7F8F7]/95 backdrop-blur-lg">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link
          to="/agencies"
          onClick={closeMenu}
          className="flex items-center gap-3 transition-opacity hover:opacity-75"
          aria-label="RepUpgrade agency homepage"
        >
          <img
            src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/72d2508c2498c1755558cb43ced92309.png"
            alt="RepUpgrade"
            className="h-10 w-auto object-contain"
          />
        </Link>

        <nav className="hidden items-center gap-5 xl:flex" aria-label="Agency homepage">
          {navigation.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="text-sm font-semibold text-[#244A49] transition-colors hover:underline"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={AUTHORITY_BUILDER_LOGIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-bold text-[#244A49] transition-colors hover:underline"
          >
            Client login
          </a>
          <Link
            to="/partner-apply"
            className="inline-flex min-h-11 items-center rounded-lg bg-[#F49558] px-5 text-sm font-bold text-[#101F1F] transition-colors hover:bg-[#F6D541]"
          >
            Apply to partner
          </Link>
        </nav>

        <button
          type="button"
          aria-label={isOpen ? 'Close agency navigation' : 'Open agency navigation'}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((open) => !open)}
          className="inline-flex h-11 w-11 items-center justify-center border border-[#244A49]/15 bg-white text-[#101F1F] xl:hidden"
        >
          <SafeIcon name={isOpen ? 'X' : 'Menu'} className="h-5 w-5" />
        </button>
      </div>

      {isOpen && (
        <nav
          aria-label="Mobile agency homepage"
          className="border-t border-[#244A49]/10 bg-[#F7F8F7] px-5 py-5 xl:hidden"
        >
          <div className="mx-auto flex max-w-7xl flex-col">
            {navigation.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                onClick={closeMenu}
                className="border-b border-[#244A49]/10 py-3 text-base font-semibold text-[#244A49]"
              >
                {item.label}
              </Link>
            ))}
            <a
              href={AUTHORITY_BUILDER_LOGIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
              className="border-b border-[#244A49]/10 py-3 text-base font-semibold text-[#244A49]"
            >
              Client login
            </a>
            <Link
              to="/partner-apply"
              onClick={closeMenu}
              className="mt-5 inline-flex min-h-12 items-center justify-center bg-[#F49558] px-5 font-bold text-[#101F1F] transition-colors hover:bg-[#F6D541]"
            >
              Apply to partner
            </Link>
          </div>
        </nav>
      )}
    </header></>
  );
}